import { getLastElOfArr } from 'services/helper';
export class TreeApiConverter {
  convertDescendants = (parentId, userId, subusersCount = 0, level = 1, username) => ({
    parentId,
    subusersCount,
    userId,
    level,
    username,
  });

  convertUsersById = ({ data, id }) => {
    const { path, descendants } = data;

    const parents = path
      .map(el => ({
        ...this.convertDescendants(el.parent_agent_id, el.id, 1, 1, el.username),
        isOpened: true,
      }))
      .filter(el => el.parent_agent_id !== null);

    const parsedDescendants = descendants.map(t =>
      this.convertDescendants(id, t.id, t.child_count, t.level, t.username),
    );

    function buildSearchTree(searchTree, descendants) {
      // Проверка наличия descendants
      if (!descendants || descendants.length === 0) {
        return null;
      }

      const root = searchTree[0];
      const tree = { ...root };

      function addChildren(node, parentId) {
        const children = searchTree.filter(parent => parent.parentId === parentId);
        if (children.length === 0) {
          return;
        }

        node.childrens = [];

        children.forEach(child => {
          const childNode = { ...child };
          addChildren(childNode, child.userId);
          node.childrens.push(childNode);
        });
      }

      addChildren(tree, root.userId); // рекурсивно добавляем childrenов

      return [tree];
    }

    // добавляем найденного юзера в общий массив и также убираем самого верхнего родителя
    const searchTree =
      descendants.length === 1
        ? [
            ...parents,
            {
              parentId: parents.at(-1).userId,
              subusersCount: 0,
              userId: descendants[0].id,
              level: parents.length,
              username: descendants[0].username,
              isOpened: true,
            },
          ].filter(el => el.parentId !== null)
        : [...parents.filter(el => el.parentId !== null)];

    const parentTree = searchTree.length === 0 ? [] : buildSearchTree(searchTree, descendants);

    return [parsedDescendants, parentTree];
  };
}
